import type { MaybeRefOrGetter } from 'vue';
import type { Uuid } from '#layers/data-model/public';
import { computed, toValue } from 'vue';

export interface UseStorageKeyOptions {
	scope?: MaybeRefOrGetter<readonly (string | null | undefined)[]>;
	ownerId?: MaybeRefOrGetter<Uuid | null>;
}

/** Builds a reactive storage key from ordered scope parts and keeps its owner metadata in sync. */
export function useStorageKey(key: MaybeRefOrGetter<string>, options?: UseStorageKeyOptions) {
	const ownerId = computed(() => toValue(options?.ownerId) ?? null);

	const storageKey = computed(() =>
		[toValue(key), ...(toValue(options?.scope) ?? []), ownerId.value]
			.filter(Boolean)
			.join(':'),
	);

	return { storageKey, ownerId };
}
